module.exports = __webpack_public_path__ + "static/media/africa_getty.008f180e.jpg";